import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Intro = styled.header`
  margin-bottom: 2.8rem;
`;
